import service from '../axios'
import { mockApi } from '../mock'

// 是否使用mock数据
const useMock = process.env.NODE_ENV === 'development'

export const homeApi = {
  // 获取首页数据
  getHomeData() {
    if (useMock) {
      return mockApi.getHomeData()
    }
    return service.get('/home')
  }
}